import React from 'react';
import { Button, ButtonToolbar, Modal, ModalBody, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';

const ScoreModal = (props) => {
  const {
    handleSubmitScore,
    initialScoreValue,
    onChangeInput,
    scoreOptions,
    loading,
    isOpen,
    toggle,
    score,
  } = props;
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="modal-dialog modal-dialog--success crm-score-modal-content"
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
          <h2 className="bold-text label_autofin  modal__title" style={{ fontWeight: 'bold', textAlign: 'left' }}>
            <strong>Calificación</strong>
          </h2>
        </div>
        <form onSubmit={handleSubmitScore}>
          <ModalBody className='crm-score-modal'>
            <Select
              options={[initialScoreValue, ...scoreOptions]}
              name="score"
              placeholder="Seleccione"
              id="score"
              isDisabled={loading}
              value={score}
              onChange={onChangeInput('score')}
              required
            />
          </ModalBody>
          <ButtonToolbar className="score-modal__footer">
            <Button className="asignar" onClick={toggle} disabled={loading}>Cancelar</Button>{' '}
            <Button
              className="asignar just_this"
              type="submit"
              id="added"
              disabled={loading || !score?.value}
            >
              {loading && <Spinner />}
              Cerrar Caso
            </Button>
          </ButtonToolbar>
        </form>
      </Modal>
    </div>
  );
};

ScoreModal.propTypes = {
  handleSubmitScore: PropTypes.func.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  score: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  initialScoreValue: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  scoreOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};

export default ScoreModal;